import { useEffect } from 'react';

declare global {
  interface Window {
    fbq: (action: string, event: string, params?: Record<string, unknown>) => void;
  }
}

export function useMetaPixel(trackPageView: boolean = false) {
  useEffect(() => {
    if (trackPageView && typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [trackPageView]);
}
